import { Badge } from "@chakra-ui/react";
import { sourceLabels } from "../mappers/screening.mapper";
import { ScreeningSource } from "../types";

const sourceColors: Record<ScreeningSource, { bg: string; color: string }> = {
  rentalsAgent: { bg: "#EDEBFF", color: "#7B61FA" },
  tenantPortal: { bg: "#E8F1FF", color: "#4A7DD8" },
  paymentHistory: { bg: "#F7F7F7", color: "#5D5C60" },
  analyst: { bg: "#FFF4E5", color: "#B7791F" },
};

type Props = { source: ScreeningSource };

const SourceBadge = ({ source }: Props): JSX.Element => (
  <Badge
    bg={sourceColors[source].bg}
    color={sourceColors[source].color}
    size="md"
  >
    {sourceLabels[source]}
  </Badge>
);

export default SourceBadge;
